import React from 'react';
import { Globe, Mail, Instagram, MessageCircle } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    lang
  } = useLanguage();
  const navLinks = [{
    label: lang === 'es' ? 'Inicio' : 'Home',
    href: '#inicio'
  }, {
    label: lang === 'es' ? 'Servicios' : 'Services',
    href: '#servicios'
  }, {
    label: lang === 'es' ? 'Portafolio' : 'Portfolio',
    href: '#portafolio'
  }, {
    label: lang === 'es' ? 'Sobre mí' : 'About me',
    href: '#sobre'
  }, {
    label: 'FAQ',
    href: '#faq'
  }, {
    label: lang === 'es' ? 'Contacto' : 'Contact',
    href: '#contacto'
  }];
  return <footer className="bg-inkova-dark pt-16 pb-8 text-white/70" data-id="element-142">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr] gap-12 lg:gap-16 mb-12" data-id="element-144">
          {/* Brand */}
          <div data-id="element-145">
            <div className="flex items-center gap-3 mb-4" data-id="element-146">
              <img src="https://cdn.magicpatterns.com/uploads/owVcxkWT6ABhGYw2qQLWVA/INK_PNG.png" alt="Inkova Creation" className="h-9 w-auto block brightness-0 invert" data-id="element-147" />
              <div className="flex flex-col" data-id="element-148">
                <span className="text-[11px] text-inkova-accent" data-id="element-149">
                  Business Consulting & Creation
                </span>
              </div>
            </div>
            <p className="text-sm leading-[1.7] max-w-[300px] mb-5" data-id="element-150">
              {lang === 'es' ? 'Tu negocio digital construido desde tu identidad y propósito. Miami, Florida.' : 'Your digital business built from your identity and purpose. Miami, Florida.'}
            </p>
            <div className="text-[13px] space-y-2" data-id="element-151">
              <div className="flex items-center gap-2" data-id="element-152">
                <Globe className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-153" />
                <a href="https://inkovacreation.com" className="text-inkova-accent hover:opacity-70 transition-opacity" data-id="element-154">
                  inkovacreation.com
                </a>
              </div>
              <div className="flex items-center gap-2" data-id="element-155">
                <Mail className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-156" />
                <a href="mailto:info@inkovacreation.com" className="text-inkova-accent hover:opacity-70 transition-opacity" data-id="element-157">
                  info@inkovacreation.com
                </a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div data-id="element-158">
            <h4 className="text-white text-[13px] font-semibold tracking-[1px] uppercase mb-5" data-id="element-159">
              {lang === 'es' ? 'Navegación' : 'Navigation'}
            </h4>
            <ul className="flex flex-col gap-3" data-id="element-160">
              {navLinks.map((link, index) => <li key={index} data-id="element-161">
                  <a href={link.href} className="text-sm hover:text-inkova-accent transition-colors duration-200" data-id="element-162">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-163">
            <h4 className="text-white text-[13px] font-semibold tracking-[1px] uppercase mb-5" data-id="element-164">
              {lang === 'es' ? 'Síguenos' : 'Follow us'}
            </h4>
            <div className="flex flex-col gap-3" data-id="element-165">
              <a href="https://instagram.com/inkovacreation" target="_blank" rel="noopener noreferrer" className="text-sm flex items-center gap-2.5 hover:text-inkova-accent transition-colors duration-200" data-id="element-166">
                <Instagram className="w-4 h-4 shrink-0" strokeWidth={1.5} data-id="element-167" />
                @inkovacreation
              </a>
              <a href="https://wa.me/13054781618" target="_blank" rel="noopener noreferrer" className="text-sm flex items-center gap-2.5 hover:text-inkova-accent transition-colors duration-200" data-id="element-168">
                <MessageCircle className="w-4 h-4 shrink-0" strokeWidth={1.5} data-id="element-169" />
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-7 flex flex-col sm:flex-row justify-between items-center gap-4 text-center sm:text-left" data-id="element-170">
          <p className="text-[13px]" data-id="element-171">
            {lang === 'es' ? '© 2026 Inkova Creation. Todos los derechos reservados.' : '© 2026 Inkova Creation. All rights reserved.'}
          </p>
          <p className="text-xs" data-id="element-172">
            {lang === 'es' ? 'Diseñado con propósito · Miami, Florida 🌴' : 'Designed with purpose · Miami, Florida 🌴'}
          </p>
        </div>
      </div>
    </footer>;
}